import { useMemo } from "react";
import PropTypes from "prop-types";

import {
  EMAIL_PREVIEW_SANDBOX,
  rewriteEmailPreviewLinks,
} from "helpers/emailPreview";

/**
 * Sandboxed iframe for rendering email HTML, with links rewritten to open in a
 * new tab.
 */
const EmailHtmlFrame = ({
  html,
  title,
  autoHeight = false,
  minHeight = 400,
  style,
}) => {
  const srcDoc = useMemo(() => rewriteEmailPreviewLinks(html), [html]);

  const adjustHeight = event => {
    const iframe = event.target;
    iframe.style.height = `${iframe.contentWindow.document.body.scrollHeight}px`;
  };

  return (
    <iframe
      title={title}
      srcDoc={srcDoc}
      sandbox={EMAIL_PREVIEW_SANDBOX}
      onLoad={autoHeight ? adjustHeight : undefined}
      style={{
        width: "100%",
        border: "none",
        background: "#fff",
        ...(autoHeight ? {} : { minHeight }),
        ...style,
      }}
    />
  );
};

EmailHtmlFrame.propTypes = {
  html: PropTypes.string,
  title: PropTypes.string.isRequired,
  autoHeight: PropTypes.bool,
  minHeight: PropTypes.number,
  style: PropTypes.object,
};

export default EmailHtmlFrame;
